<script lang="ts">
  import Image from '$mds/Image';
  import { pluralize } from '$lib/utils';
  import Tag from '$mds/Tag';

  type GroupItem = {
    id: string;
    slug: string;
    title: string;
    logo: string;
    cover: string;
    member_count: number;
    visibility: string;
  };

  export let group: GroupItem & { _formatted?: GroupItem };

  let className = 'sm:hover:bg-ondark-low';
  export { className as class };
</script>

<a
  href="/communities/{group?.slug}"
  class="focus-visible:bg-ondark-low focus-visible:ring-ondark-focused group flex h-14 items-center justify-between space-x-3 rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 sm:px-3 {className}"
  on:keydown
  on:click
>
  <div class="flex min-w-0 flex-1 items-center space-x-4">
    <Image
      src={group.logo ?? group.cover}
      class="aspect-video h-6 w-auto object-cover"
      sizes={{ xs: 24 }}
      alt={group.title}
      rounded="rounded"
    />
    <span class="flex items-end gap-2 overflow-hidden">
      <span class="highlight text-ondark-primary inline-block truncate">
        {@html group._formatted?.title ?? group.title ?? ''}
      </span>
    </span>
  </div>
  <div class="flex min-w-0 items-center space-x-1.5">
    <Tag variant="secondary" class="capitalize" title="Group type">
      {group?.visibility}
    </Tag>
    <Tag variant="secondary" class="capitalize">
      {pluralize('member', group?.member_count)}
    </Tag>
  </div>
</a>
